/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconScooterElectric = createReactComponent("outline", "scooter-electric", "IconScooterElectric", [["path", { "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1", "key": "svg-2" }], ["path", { "d": "M10 4l-2 4h3l-2 4", "key": "svg-3" }]]);

export { IconScooterElectric as default };
//# sourceMappingURL=IconScooterElectric.mjs.map
